import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOfficeOrigin = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/OfficeOrigin`
  );
  return data;
};
// Insert New OfficeOrigin
export const addOfficeOrigin = async (newOfficeOrigin) => {
  const { data } = await axios.post(
    `${api_base_url}/Configuration/OfficeOrigin`,
    {
      ...newOfficeOrigin[0],
    }
  );
  return data;
};
// Update OfficeOrigin

export const updateOfficeOrigin = async (officeOrigin) => {
  const { data } = await axios.put(
    `${api_base_url}/Configuration/OfficeOrigin${officeOrigin[0].officeOriginId}`,
    officeOrigin[0]
  );
  return data;
};

export const deleteOfficeOrigin = async (ids) => {
  await axios.delete(`${api_base_url}/Configuration/OfficeOrigin`, {
    data: ids,
  });
};
